/*=============================
=             Hero            =
=============================*/

var slidesContainer = document.getElementById('slides');

if(slidesContainer) {
	var slides = slidesContainer.querySelectorAll('li'),
		heroControls = document.getElementById('hero-controls'),
		playPauseHero = heroControls.firstElementChild,
		bullets = [].slice.call(heroControls.querySelectorAll('li button')),
		currentBullet = 0,
		heroTimeout,
		runHero = function() {
			currentBullet = (currentBullet + 1) % bullets.length;
			toggleBullets(bullets[currentBullet]);
			startSlide(false);
		};

	setTimeout(startSlide, 0);

	bullets.forEach(function(bullet) {
		bullet.addEventListener('click', function() {
			clearTimeout(heroTimeout);

			toggleBullets(this);
			currentBullet = bullets.indexOf(bullet);
			startSlide(true);
		});
	});

	playPauseHero.addEventListener('click', function() {
		var isPlay = this.classList.contains('play');

		if(isPlay)
			heroTimeout = setTimeout(runHero, 1500);
		else
			clearTimeout(heroTimeout);

		this.className = isPlay ? 'pause' : 'play';
		this.setAttribute('aria-label', (isPlay ? 'Pause' : 'Play')+' Hero');
	});
}

function startSlide(click) {
	var currentSlide = slidesContainer.querySelector('.current');

	if(slidesContainer.classList.contains('with-animation')) {
		[].slice.call(slidesContainer.querySelectorAll('li:not(.current)')).forEach(function(slide) {
			slide.querySelector('div.title').setAttribute('style', '');
			slide.querySelector('p').setAttribute('style', '');
		});

		setTransition(currentSlide.querySelector('div.title'), currentSlide.querySelectorAll('p'), click);
	}

	if(playPauseHero.classList.contains('pause'))
		heroTimeout = setTimeout(runHero, 7500);
}

function toggleBullets(bullet) {
	var bulletIndex = bullets.indexOf(bullet);

	document.querySelector('#hero-controls .current').classList.remove('current');
	slidesContainer.querySelector('li.current').classList.remove('current');

	slides[bulletIndex].classList.add('current');

	bullet.classList.add('current');
}

function setTransition(title, text, click) {
	setTimeout(function() {
		title.setAttribute('style', 'opacity: 1; transform: none;'+(click ? ' transition: opacity .2s' : ''));
	}, (click ? 100 : 900));

	Velocity(text, {opacity: [1,0]}, (click ? {duration: 200} : {duration: 300, delay: 1700}));
}

/*=============================
=          Physicians         =
=============================*/

var doctorsSlider = document.getElementById('doctors-slider');

if(doctorsSlider) {
	var doctorsCards = doctorsSlider.querySelectorAll('.image-card'),
		cardsTotal = doctorsCards.length,
		currentCard = 0,
		autoSlidePhysician = function() {
			slidePhysician('next');
		},
		cardInterval = setInterval(autoSlidePhysician, 5000);

	[].slice.call(doctorsSlider.querySelectorAll('button')).forEach(function(button) {
		button.addEventListener('click', function() {
			clearInterval(cardInterval);
			slidePhysician(button.className);
		});
	});

	function slidePhysician(direction) {
		var isNext = direction == 'next',
			numDisplay = checkWidth(1024) ? 2 : (checkWidth(1200) ? 3 : 4),
			cardTransform = checkWidth(1024) ? 51.7008 : (checkWidth(1200) ? 34.1233 : (checkWidth(1367) ? 25.6412 : 25.7144));

		currentCard = (currentCard + numDisplay) == cardsTotal ? 0 : (isNext ? ++currentCard : --currentCard);

		doctorsSlider.querySelector('.cards-container').style.transform = 'translateX('+(currentCard ? -(currentCard * cardTransform) : 0)+'%)';
		doctorsSlider.querySelector('button.prev').disabled = currentCard === 0 ? true : false;
		doctorsSlider.querySelector('button.next').disabled = (currentCard + numDisplay) == cardsTotal ? true : false;
	}
}

/*=============================
=          Google Map         =
=============================*/

var mapSection = document.getElementById('section_map'),
	mapContainer = mapSection ? mapSection.querySelector('.map-container') : false;

function initMap() {
	var map,
		openWindow;

	axios.get('/map-section/all').then(function(r) {
		var locations = r.data.locations,
			center = new google.maps.LatLng(45.5658378758426, -93.21922566664023), // Get coordinates of location on the center of the map
			mapOptions = {
				zoom: checkWidth(768) ? 7 : 8,
				streetViewControl: false, // hide the yellow Street View pegman
				scaleControl: true, // allow users to zoom the Google Map
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				scrollwheel: false,
				center: center,
				styles: mapStyles
			};

		map = new google.maps.Map(mapContainer, mapOptions);

		locations.forEach(function(location) {
			var coordinates = JSON.parse('['+location.coordinates.value+']'),
				latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
				infowindow = new google.maps.InfoWindow({
					position: latLng,
					content: location.html
				}),
				marker = new google.maps.Marker({
					map: map,
					position: latLng,
					draggable: false,
					animation: google.maps.Animation.DROP,
					icon: '/assets/images/icons/map-pin.svg'
				});

			if(!openWindow && !checkWidth(768)) {
				infowindow.open(map, marker); // Remove this to close infowindow by default
				openWindow = infowindow;
			}

			infowindow.addListener('closeclick', function() {
	        	openWindow = false;
	        });

	        marker.addListener('click', function() {
	        	if(openWindow)
	        		openWindow.close();

	      		if(openWindow != infowindow) {
	      			infowindow.open(map, marker);
	      			openWindow = infowindow;
	      		}
	      		else
	      			openWindow = false;
	        });
		});
	});
}

if(mapSection)
	window.initMap = initMap;